import { styled, Divider as MUIDivider } from "@mui/material";

const Divider = styled(MUIDivider)(({ theme }) => ({
  borderTop: "0px solid rgba(0, 0, 0, 0.12)",
  borderRight: "0px solid rgba(0, 0, 0, 0.12)",
  borderLeft: "0px solid rgba(0, 0, 0, 0.12)",
  backgroundColor: "transparent",
  height: "1px",
  borderBottom: "none",
  opacity: 0.25,
  backgroundImage:
    theme.palette.mode === "light"
      ? "linear-gradient(to right, rgba(52, 71, 103, 0), rgba(52, 71, 103, 0.4), rgba(52, 71, 103, 0)) !important"
      : "linear-gradient(to right, rgba(52, 71, 103, 0), rgb(255, 255, 255), rgba(52, 71, 103, 0)) !important",
}));

export default Divider;
